import { useQuery } from "@tanstack/react-query";
import { Check, Users, GraduationCap, Leaf } from "lucide-react";
import SEOHead, { aboutPageSEO } from "@/components/SEOHead";

export default function About() {
  const { data: content } = useQuery({
    queryKey: ["/api/content/about"],
  });

  return (
    <>
      <SEOHead {...aboutPageSEO} />
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 rounded-full bg-sailing-gold/10 text-sailing-gold font-medium text-sm mb-4">
              Our Story
            </span>
          </div>
          <h1 className="text-5xl font-bold text-navy mb-6">About Vaal Cruising Association</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">Discover our passion for boating and community</p>
        </div>

        <div className="space-y-16">
          <div className="bg-gradient-navy rounded-3xl p-12 text-white">
            <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
            <p className="text-xl leading-relaxed text-gray-100">
              {(content as any)?.content || "The Vaal Cruising Association is dedicated to promoting the sport of boating and fostering a strong community of boating enthusiasts on the Vaal Dam. We provide a welcoming environment for boaters of all experience levels, from beginners to seasoned professionals."}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-3xl font-bold text-navy mb-8">What We Offer</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-sailing-gold rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Check className="text-navy h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Regular boating events and cruises</h4>
                    <p className="text-gray-600">Recreational cruising and boating opportunities</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-sailing-gold rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Check className="text-navy h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Training programs for beginners</h4>
                    <p className="text-gray-600">Learn to boat with certified instructors</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-sailing-gold rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Check className="text-navy h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Social gatherings and networking</h4>
                    <p className="text-gray-600">Build connections with fellow boating enthusiasts</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-sailing-gold rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Check className="text-navy h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Access to club facilities</h4>
                    <p className="text-gray-600">Modern marina and clubhouse amenities</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-sailing-gold rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <Check className="text-navy h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Equipment rental and maintenance</h4>
                    <p className="text-gray-600">Professional boat care and rental services</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-ocean rounded-3xl opacity-20"></div>
              <img 
                src="/attached_assets/VCA photos (751) - Copy_1750074778096.jpg" 
                alt="VCA mooring facilities at Aloe Fjord" 
                className="relative rounded-2xl shadow-2xl w-full"
              />
            </div>
          </div>

          <div className="bg-soft-gray rounded-3xl p-12">
            <h3 className="text-3xl font-bold text-navy mb-12 text-center">Our Values</h3>
            <div className="grid md:grid-cols-3 gap-12">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-ocean rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Users className="text-white h-10 w-10" />
                </div>
                <h4 className="text-xl font-bold mb-4 text-navy">Community</h4>
                <p className="text-gray-600 leading-relaxed">Building lasting friendships through shared passion for boating and the water</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-sailing-gold rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <GraduationCap className="text-navy h-10 w-10" />
                </div>
                <h4 className="text-xl font-bold mb-4 text-navy">Education</h4>
                <p className="text-gray-600 leading-relaxed">Continuous learning and skill development for boaters of all levels</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-navy rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <Leaf className="text-white h-10 w-10" />
                </div>
                <h4 className="text-xl font-bold mb-4 text-navy">Environment</h4>
                <p className="text-gray-600 leading-relaxed">Protecting our beautiful Vaal Dam ecosystem for future generations</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}
